<template>
  <div>
    <div v-if="pageLoading" class="h-screen w-screen grid place-items-center">
      <div
        class="flex items-center font-logo font-bold text-4xl text-light-purple animate-pulse"
      >
        Blüm Report
      </div>
    </div>
    <div v-else-if="report" :class="{ 'select-none': dragMove }">
      <ReportHeader
        :mode="mode"
        :saving="saving"
        @change-mode="mode = $event"
      />
      <div class="flex" :style="{ minHeight: 'calc(100vh - 3.75rem)' }">
        <div class="w-20 flex-shrink-0"></div>

        <Editor
          :mode="mode"
          :sectionFocusedId="sectionFocusedId"
          :dragMove="dragMove"
          :dragTarget="dragTarget"
          @change-saving="saving = $event"
          @change-focus-id="sectionFocusedId = $event"
        />

        <ReportHelper
          v-if="mode === 'edit'"
          :sectionFocusedId="sectionFocusedId"
          :dragId="dragId"
          @change-focus-id="sectionFocusedId = $event"
          @drag-start="dragStart"
        />
        <div v-else class="w-20 flex-shrink-0"></div>
      </div>
    </div>

    <div
      v-if="dragTarget"
      ref="blClientTargetDecoy"
      :style="{
        left: `${dragPos.x}px`,
        top: `${dragPos.y}px`,
        width: `${dragPos.w}px`,
        zIndex: 100
      }"
      class="pointer-events-none fixed"
    >
      <div
        class="w-104 py-2 px-2 flex items-center justify-between gap-2 bg-pure-white border border-slate-400 rounded"
      >
        <div class="flex items-center gap-2 truncate" :title="dragTarget.name">
          <div>
            <BlIcon icon="drag" color="slate-8" class="h-5 w-5" />
          </div>
          <BlTextBody2 :text="dragTarget.name" class="truncate" />
        </div>
        <div class="flex items-center gap-2">
          <div
            class="flex"
            :class="{ 'opacity-0': dragTarget.type === 'cumulative' }"
          >
            <BlChip
              :chip="
                dragTarget.status === 'in_progress'
                  ? 'in_acquisition'
                  : dragTarget.status
              "
            />
          </div>
          <div title="Add graph">
            <BlIcon icon="plus" color="slate-8" class="h-4 w-4" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import ReportHeader from "./ReportHeader.vue";
import Editor from "./Editor.vue";
import ReportHelper from "./ReportHelper.vue";

import BlTextBody2 from "../BlTextBody2.vue";
import BlIcon from "../BlIcon.vue";
import BlChip from "../BlChip.vue";

export default {
  name: "Report",
  components: {
    ReportHeader,
    Editor,
    ReportHelper,
    BlTextBody2,
    BlIcon,
    BlChip
  },
  data() {
    return {
      pageLoading: true,
      saving: false,
      mode: "edit", // edit | preview
      sectionFocusedId: 0,
      //
      dragX: 0,
      dragY: 0,
      dragPos: { x: 0, y: 0, w: 0 },
      dragMove: false,
      dragId: 0,
      dragTarget: null
    };
  },
  computed: {
    ...mapGetters(["targets", "report", "sections", "client"])
  },
  watch: {
    sectionFocusedId(val) {
      if (!val) return;
      const el = document.getElementById(`report-section-${val}`);
      if (!el) return;
      el.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      });
    }
  },
  mounted() {
    const app = document.getElementById("app");
    if (app) {
      app.classList.add("bg-pure-white");
      app.classList.remove("bg-slate-200");
    }
    this.fetchReport();
  },
  destroyed() {
    const app = document.getElementById("app");
    if (app) {
      app.classList.remove("bg-pure-white");
      app.classList.add("bg-slate-200");
    }
  },
  methods: {
    ...mapActions(["getTargets", "getReport", "getSections"]),
    async fetchReport() {
      const id = this.$route.params.id;
      const slug = this.$route.params.slug;
      this.getTargets({ params: `?client_id=${id}&sort=alphabetical` });

      this.pageLoading = true;
      await this.getReport({ slug });
      // await this.getSections({ slug });
      this.pageLoading = false;
    },
    //
    dragStart(payload) {
      const e = payload.e;
      const clientTarget = payload.client_target;
      const target = e.target ? e.target.parentElement : null;

      if (!clientTarget.id) return;

      if (target && clientTarget) {
        if (e.type === "mousedown") {
          this.sectionFocusedId = 0;

          const { x, y, width } = target.getBoundingClientRect();

          this.dragX = e.clientX;
          this.dragY = e.clientY;
          this.dragId = Number(clientTarget.id);
          this.dragPos = { x, y, w: width };

          this.dragTarget = clientTarget;
          window.addEventListener("mousemove", this.drag);
          window.addEventListener("mouseup", this.dragEnd);
        } else {
          window.addEventListener("touchmove", this.drag);
          window.addEventListener("touchend", this.dragEnd);
        }
      }
    },
    drag(e) {
      this.dragMove = true;
      let dx = 0;
      let dy = 0;

      if (e.type === "mousemove") {
        dx = e.clientX - this.dragX;
        dy = e.clientY - this.dragY;
      }
      if (this.$refs.blClientTargetDecoy) {
        this.$refs.blClientTargetDecoy.style.transform = `translate3d(${dx}px, ${dy}px, 0)`;
      }
    },
    dragEnd() {
      setTimeout(() => {
        this.dragPos = { x: 0, y: 0, w: 0 };
        this.dragId = 0;
        this.dragTarget = null;
        this.dragMove = false;
        window.removeEventListener("mousemove", this.drag);
        window.removeEventListener("mouseup", this.dragEnd);
        window.removeEventListener("touchmove", this.drag);
        window.removeEventListener("touchend", this.dragEnd);
      }, 10);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/reports/Report.vue